module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contBtn),
      expression: "contBtn"
    }],
    staticClass: "button-next",
    on: {
      "click": _vm.next
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/btn_continue.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-title"
  }, [_vm._v(_vm._s(_vm.items.globalButtons.continueButton))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1bbb96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonNext.vue
// module id = 140
// module chunks = 0